(function () {
  'use strict';

  function initIyraPurchasePanel() {
    var root = document.querySelector('.iyra-product-page');
    if (!root || root.dataset.iyraPanelReady === 'true') return;

    var sourcePriceList = root.querySelector('[data-product-price-list]');
    var configuredPrice = root.querySelector('[data-iyra-checkout-price]');
    var installment = root.querySelector('[data-iyra-installment]');
    if (!sourcePriceList || !configuredPrice || !installment) return;

    root.dataset.iyraPanelReady = 'true';

    var standardDelivery = 'Free Standard Delivery (8–10 Weeks)';
    var expressDelivery = 'Express Shipping (5–6 Weeks)';

    function dispatchValue(input, value, price) {
      if (!input) return;
      var nextPrice = String(price || 0);
      var changed = input.value !== value || input.getAttribute('ymq-option-price') !== nextPrice;
      input.value = value;
      input.setAttribute('ymq-option-price', nextPrice);
      if (changed) input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function sourcePriceNode() {
      return sourcePriceList.querySelector('.ymq-price-span') ||
        sourcePriceList.querySelector('[data-ymq-money]') ||
        sourcePriceList.querySelector('.price--highlight') ||
        sourcePriceList.querySelector('.price');
    }

    function numericPrice(node) {
      if (!node) return NaN;
      var dataValue = node.getAttribute('data-ymq-money');
      if (dataValue !== null && dataValue !== '') {
        var parsedDataValue = Number(dataValue);
        if (Number.isFinite(parsedDataValue)) return parsedDataValue;
      }

      var normalized = node.textContent.replace(/[^0-9,.-]/g, '').replace(/,/g, '');
      return Number(normalized);
    }

    function formatMoney(value) {
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'USD';
      var locale = document.documentElement.lang || 'en-US';

      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      } catch (error) {
        return '$' + value.toFixed(2);
      }
    }

    function updateDisplay() {
      var source = sourcePriceNode();
      var value = numericPrice(source);
      if (!source || !Number.isFinite(value)) return;

      configuredPrice.textContent = source.textContent.trim() || formatMoney(value);
      installment.textContent = formatMoney(value / 4);
      syncDeliveryEligibility();
    }

    new MutationObserver(updateDisplay).observe(sourcePriceList, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true
    });

    root.addEventListener('change', function () {
      window.setTimeout(updateDisplay, 0);
      window.setTimeout(updateDisplay, 200);
    });

    root.addEventListener('click', function () {
      window.setTimeout(updateDisplay, 0);
      window.setTimeout(updateDisplay, 250);
    });

    var configurator = root.querySelector('.iyra-purchase-configurator');
    var availabilitySelector = [
      '.custom-option-select-demister',
      '.custom-option-select-mirror',
      '.custom-option-select-bluetooth',
      '.custom-option-select-wifi',
      '.custom-option-select-clock'
    ].join(', ');

    function optionFieldName(field) {
      var label = field.querySelector(':scope > label');
      if (!label) return 'This option';
      var textNode = Array.prototype.find.call(label.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      return textNode ? textNode.textContent.replace(/\s+/g, ' ').trim() : 'This option';
    }

    function inchValue(value) {
      var match = String(value || '').match(/\d+(?:\.\d+)?/);
      return match ? match[0] + '″' : String(value || '').trim();
    }

    function currentSizeCopy() {
      var diameter = root.querySelector('.diameterSize-inch');
      var width = root.querySelector('.widthSize-inch');
      var height = root.querySelector('.heightSize-inch');
      if (diameter && diameter.textContent.trim()) {
        return 'Current size: ' + inchValue(diameter.textContent) + ' diameter.';
      }
      if (width && height) {
        return 'Current size: ' + inchValue(width.textContent) + ' × ' + inchValue(height.textContent) + '.';
      }
      return '';
    }

    function restrictionCopy(field) {
      var restriction = field.querySelector('.option-label-i-content i');
      var raw = restriction ? restriction.textContent.replace(/\s+/g, ' ').trim() : '';
      var values = raw.match(/\d+(?:\.\d+)?/g) || [];
      var fieldName = optionFieldName(field).toLowerCase();
      var isRound = !!root.querySelector('.diameterSize-inch');
      var copy = '';

      var directRequirement = null;
      var currentSizeLabel = 'Current size';
      if (fieldName.indexOf('clock') !== -1 && fieldName.indexOf('wi-fi') !== -1) {
        directRequirement = [40, 32];
        currentSizeLabel = 'Current Size';
      } else if (fieldName.indexOf('demister') !== -1 || fieldName.indexOf('bluetooth') !== -1) {
        directRequirement = [40, 32];
      } else if (fieldName.indexOf('makeup') !== -1) {
        directRequirement = [32, 48];
      }

      if (directRequirement) {
        var selectedWidth = numericSize('.widthSize-inch') || numericSize('.diameterSize-inch');
        var selectedHeight = numericSize('.heightSize-inch') || numericSize('.diameterSize-inch');
        var currentDimensions = selectedWidth && selectedHeight
          ? ' ' + currentSizeLabel + ': ' + selectedWidth + '" × ' + selectedHeight + '".'
          : '';
        return 'Requires width ≥ ' + directRequirement[0] + '" and height ≥ ' + directRequirement[1] + '". Both dimensions must meet the requirement.' + currentDimensions;
      }

      if (isRound) {
        copy = 'Requires at least ' + inchValue(values[0] || 32) + ' diameter.';
      } else if (values.length >= 2) {
        copy = 'Requires ' + inchValue(values[0]) + ' W × ' + inchValue(values[1]) + ' H.';
      } else if (values.length === 1) {
        copy = 'Requires at least ' + inchValue(values[0]) + ' width.';
      } else if (fieldName.indexOf('clock') !== -1 && fieldName.indexOf('wifi') === -1) {
        copy = 'Requires 22″ W × 30″ H.';
      } else if (fieldName.indexOf('makeup') !== -1) {
        copy = 'Requires at least 32″ width.';
      } else {
        copy = 'Requires 40″ W × 32″ H.';
      }

      var current = currentSizeCopy();
      return current ? copy + ' ' + current : copy;
    }

    function isNoneOption(option) {
      var value = (option.getAttribute('data-val') || option.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      return value === 'none' || value.indexOf('none ') === 0;
    }

    function hasDirectSizeRequirement(field) {
      var fieldName = optionFieldName(field).toLowerCase();
      return fieldName.indexOf('demister') !== -1 ||
        fieldName.indexOf('makeup') !== -1 ||
        fieldName.indexOf('bluetooth') !== -1 ||
        (fieldName.indexOf('clock') !== -1 && fieldName.indexOf('wi-fi') !== -1);
    }

    function numericSize(selector) {
      var element = root.querySelector(selector);
      if (!element) return 0;
      var match = element.textContent.match(/\d+(?:\.\d+)?/);
      return match ? Number(match[0]) : 0;
    }

    function findOption(field, expectedValue) {
      return Array.prototype.find.call(field.querySelectorAll('.product-options-single'), function (option) {
        return (option.getAttribute('data-val') || '').trim().toLowerCase() === expectedValue.toLowerCase();
      });
    }

    function setFieldDefault(field, inputSelector, expectedValue) {
      if (!field || !findOption(field, expectedValue)) return;
      var label = field.querySelector('.product-options-label > span');
      var current = label ? label.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
      if (!current || current === 'select' || current === 'none') {
        label.textContent = expectedValue;
        root.querySelectorAll(inputSelector).forEach(function (input) {
          var inputValue = (input.value || '').trim().toLowerCase();
          if (!inputValue || inputValue === 'select' || inputValue === 'none') {
            dispatchValue(input, expectedValue, 0);
          }
        });
      }
    }

    function syncOptionDefaults() {
      if (!configurator) return;
      var defaults = [
        ['.custom-option-select-edge', '.mirror-edge input'],
        ['.product-options-label[data-attr="Backlight"]', '.backlight input']
      ];

      defaults.forEach(function (entry) {
        var element = configurator.querySelector(entry[0]);
        var field = element && element.classList.contains('custom-option-select')
          ? element
          : element && element.closest('.custom-option-select');
        setFieldDefault(field, entry[1], 'None');
      });
    }

    function syncColorTemperaturePricing() {
      if (!configurator) return;
      var trigger = configurator.querySelector('.product-options-label[data-attr="Color Temperature"]');
      var field = trigger && trigger.closest('.custom-option-select');
      var label = trigger && trigger.querySelector(':scope > span');
      var selected = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      var triColor = 'Tri-color - 3000K / 4000K / 6000K';
      var freeColors = [
        'Cool White - 6000K',
        'Neutral White - 4000K',
        'Warm White - 3000K'
      ];

      if (field) {
        field.querySelectorAll('.product-options-single').forEach(function (option) {
          var value = (option.getAttribute('data-val') || '').replace(/\s+/g, ' ').trim();
          var container = option.querySelector('.product-options-single-con') || option;
          var priceLabels = Array.prototype.filter.call(container.querySelectorAll('span'), function (span) {
            return /^\s*\+?\$?\d+(?:\.\d{1,2})?\$?\s*$/.test(span.textContent || '');
          });

          if (freeColors.indexOf(value) !== -1) {
            option.removeAttribute('data-price');
            priceLabels.forEach(function (priceLabel) { priceLabel.remove(); });
          } else if (value === triColor) {
            option.setAttribute('data-price', '+20.00$');
            var priceLabel = priceLabels[0];
            if (!priceLabel) {
              priceLabel = document.createElement('span');
              container.appendChild(priceLabel);
            }
            priceLabel.textContent = '+$20.00';
            priceLabels.slice(1).forEach(function (duplicate) { duplicate.remove(); });
          }
        });
      }

      root.querySelectorAll('.color-temperature input').forEach(function (input) {
        if (selected.indexOf(triColor) === 0) {
          dispatchValue(input, triColor, 20);
          return;
        }
        var selectedFreeColor = freeColors.find(function (color) {
          return selected.indexOf(color) === 0;
        });
        if (selectedFreeColor) {
          dispatchValue(input, selectedFreeColor, 0);
        }
      });
    }

    function setStandardDelivery() {
      var label = configurator && configurator.querySelector('.product-options-label-rush .false-deliviry');
      if (label) label.textContent = standardDelivery;
      root.querySelectorAll('.delivery input').forEach(function (input) {
        dispatchValue(input, standardDelivery, 0);
      });
      syncAddToCartButtonState();
    }

    function selectedDeliveryValue(label) {
      var selected = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      // The generic option renderer appends the surcharge to the visible label
      // (for example, "Express Shipping (5–6 Weeks) +399.00$"). Match the
      // delivery name at the beginning so the surcharge cannot invalidate it.
      if (selected.indexOf(standardDelivery) === 0) return standardDelivery;
      if (selected.indexOf(expressDelivery) === 0) return expressDelivery;
      return selected;
    }

    function syncAddToCartButtonState() {
      var label = configurator && configurator.querySelector('.product-options-label-rush .false-deliviry');
      var selected = selectedDeliveryValue(label);
      var hasValidDelivery = selected === standardDelivery || selected === expressDelivery;
      var essentials = configurator && configurator.querySelector('.iyra-mirror-essentials');
      var hasMissingEssentials = essentials && Array.prototype.some.call(essentials.querySelectorAll('.custom-option-select'), function (field) {
        var selectedValue = field.querySelector('.product-options-label > span');
        if (!selectedValue || field.classList.contains('no-drop')) return false;
        var value = selectedValue.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        return value === '' || value === 'select';
      });
      hasValidDelivery = hasValidDelivery && !hasMissingEssentials;
      var addToCart = root.querySelector('#AddToCart');
      var placeholder = root.querySelector('.flase-add-to-cart');
      var validationMessage = root.querySelector('.add-flase-p');

      if (addToCart) {
        addToCart.classList.toggle('hidden', !hasValidDelivery);
        if (essentials) {
          addToCart.disabled = !hasValidDelivery;
          addToCart.setAttribute('aria-disabled', String(!hasValidDelivery));
        }
      }
      if (placeholder) placeholder.classList.toggle('hidden', hasValidDelivery);
      if (validationMessage) validationMessage.classList.add('hidden');
    }

    function syncDeliveryEligibility() {
      if (!configurator) return;
      var rush = configurator.querySelector('.product-options-single-rush, .product-options-single-rush-no');
      if (!rush) return;

      var longestSide = Math.max(
        numericSize('.diameterSize-inch'),
        numericSize('.widthSize-inch'),
        numericSize('.heightSize-inch')
      );
      var price = numericPrice(sourcePriceNode());
      var eligible = Number.isFinite(price) && price >= 1500 && longestSide < 80;
      // Keep the row's base click class attached. Availability is represented
      // only by the dedicated state class so it can recover when price changes.
      rush.classList.add('product-options-single');
      rush.classList.toggle('product-options-single-rush-no', !eligible);
      rush.setAttribute('aria-disabled', eligible ? 'false' : 'true');

      var description = rush.querySelector('.options-single-rush-p');
      if (description) description.style.color = eligible ? '' : '#b9083a';

      var label = configurator.querySelector('.product-options-label-rush .false-deliviry');
      var selected = selectedDeliveryValue(label);
      if (!selected || selected.toLowerCase() === 'select' || (!eligible && selected === expressDelivery)) {
        setStandardDelivery();
      }
      syncAddToCartButtonState();
    }

    function syncConfiguratorDefaults() {
      syncOptionDefaults();
      syncColorTemperaturePricing();
      syncDeliveryEligibility();
      syncAddToCartButtonState();
    }

    var unavailableTooltip = null;
    var activeUnavailableOption = null;
    var tooltipHideTimer = 0;

    function ensureUnavailableTooltip() {
      if (unavailableTooltip) return unavailableTooltip;
      unavailableTooltip = document.createElement('div');
      unavailableTooltip.id = 'iyra-unavailable-option-tooltip';
      unavailableTooltip.className = 'iyra-unavailable-tooltip';
      unavailableTooltip.setAttribute('role', 'tooltip');
      unavailableTooltip.setAttribute('aria-hidden', 'true');
      document.body.appendChild(unavailableTooltip);
      return unavailableTooltip;
    }

    function positionUnavailableTooltip(option) {
      var tooltip = ensureUnavailableTooltip();
      var rect = option.getBoundingClientRect();
      var margin = 12;
      var preferredWidth = Math.min(420, window.innerWidth - margin * 2);

      tooltip.style.width = preferredWidth + 'px';
      tooltip.style.left = '0px';
      tooltip.style.top = '0px';

      var tooltipRect = tooltip.getBoundingClientRect();
      var left = rect.left + rect.width / 2 - tooltipRect.width / 2;
      left = Math.max(margin, Math.min(left, window.innerWidth - tooltipRect.width - margin));

      var top = rect.bottom + 8;
      if (top + tooltipRect.height > window.innerHeight - margin) {
        top = Math.max(margin, rect.top - tooltipRect.height - 8);
      }

      tooltip.style.left = Math.round(left) + 'px';
      tooltip.style.top = Math.round(top) + 'px';
    }

    function showUnavailableTooltip(option) {
      if (!option || !option.classList.contains('iyra-option-unavailable')) return;
      window.clearTimeout(tooltipHideTimer);

      var reason = option.getAttribute('data-iyra-unavailable-reason');
      if (!reason) return;

      var tooltip = ensureUnavailableTooltip();
      activeUnavailableOption = option;
      tooltip.textContent = reason;
      tooltip.setAttribute('aria-hidden', 'false');
      positionUnavailableTooltip(option);
      window.requestAnimationFrame(function () {
        if (activeUnavailableOption === option) tooltip.classList.add('is-visible');
      });
    }

    function hideUnavailableTooltip(immediate) {
      if (!unavailableTooltip) return;
      window.clearTimeout(tooltipHideTimer);
      unavailableTooltip.classList.remove('is-visible');
      unavailableTooltip.setAttribute('aria-hidden', 'true');
      activeUnavailableOption = null;
      if (!immediate) {
        tooltipHideTimer = window.setTimeout(function () {
          if (unavailableTooltip) unavailableTooltip.style.width = '';
        }, 180);
      }
    }

    function availabilityDefaultConfig(field) {
      if (field.classList.contains('custom-option-select-demister')) return { inputSelector: '.demister input' };
      if (field.classList.contains('custom-option-select-mirror')) return { inputSelector: '.makeup-mirror input' };
      if (field.classList.contains('custom-option-select-bluetooth')) return { inputSelector: '.bluetooth-speaker input' };
      if (field.classList.contains('custom-option-select-wifi')) return { inputSelector: '.clock-wifi input' };
      if (field.classList.contains('custom-option-select-clock')) return { inputSelector: '.clock input' };
      return null;
    }

    function syncAvailabilityDefault(field, unavailable) {
      var config = availabilityDefaultConfig(field);
      if (!config || !findOption(field, 'None')) return;

      var label = field.querySelector('.product-options-label > span');
      if (!label) return;
      var current = label.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var wasAutoNone = field.dataset.iyraAutoNone === 'true';
      var initialized = field.dataset.iyraAvailabilityInitialized === 'true';

      if (unavailable) {
        label.textContent = 'None';
        root.querySelectorAll(config.inputSelector).forEach(function (input) {
          dispatchValue(input, 'None', 0);
        });
        field.dataset.iyraAutoNone = 'true';
      } else if (wasAutoNone || (!initialized && current === 'none')) {
        label.textContent = 'Select';
        root.querySelectorAll(config.inputSelector).forEach(function (input) {
          dispatchValue(input, '', 0);
        });
        delete field.dataset.iyraAutoNone;
      }

      field.dataset.iyraAvailabilityInitialized = 'true';
    }

    function syncAvailabilityField(field) {
      // These accessories are available throughout the supported size range.
      // Clear any legacy size-lock class left by older product scripts.
      field.classList.remove('no-drop');
      var unavailable = false;
      var content = field.querySelector('.product-options-content');
      field.classList.add('iyra-availability-control');
      syncAvailabilityDefault(field, unavailable);

      field.querySelectorAll('.product-options-single').forEach(function (option) {
        var optionUnavailable = unavailable && !isNoneOption(option);
        option.classList.toggle('iyra-option-unavailable', optionUnavailable);
        if (optionUnavailable) {
          var unavailableReason = hasDirectSizeRequirement(field)
            ? restrictionCopy(field)
            : optionFieldName(field) + ' is unavailable. ' + restrictionCopy(field);
          option.setAttribute('aria-disabled', 'true');
          option.setAttribute('aria-describedby', 'iyra-unavailable-option-tooltip');
          option.setAttribute('data-iyra-unavailable-reason', unavailableReason);
          option.removeAttribute('title');
        } else {
          option.removeAttribute('aria-disabled');
          option.removeAttribute('aria-describedby');
          option.removeAttribute('data-iyra-unavailable-reason');
          option.removeAttribute('title');
          if (option === activeUnavailableOption) hideUnavailableTooltip(true);
        }
      });

      if (!content) return;
      var note = content.querySelector('.iyra-option-availability-note');
      if (unavailable) {
        if (!note) {
          note = document.createElement('div');
          note.className = 'iyra-option-availability-note iyra-option-availability-note--attention';
          note.setAttribute('role', 'status');
          note.innerHTML = '<strong></strong><span></span>';
          content.appendChild(note);
        }
        note.querySelector('strong').textContent = optionFieldName(field) + ' is unavailable for this size.';
        note.querySelector('span').textContent = restrictionCopy(field);
      } else if (note) {
        note.remove();
      }
    }

    function syncBeveledEdgeAvailability() {
      if (!configurator) return;
      var field = configurator.querySelector('.custom-option-select-edge');
      if (!field) return;

      // Never block the complete field: customers must still be able to choose None.
      field.classList.remove('no-drop');
      field.classList.add('iyra-availability-control');

      var limit = Number(field.getAttribute('data-edge-limit')) || 78;
      var diameter = numericSize('.diameterSize-inch');
      var width = numericSize('.widthSize-inch') || diameter;
      var height = numericSize('.heightSize-inch') || diameter;
      var unavailable = width > limit || height > limit;
      var beveled = Array.prototype.find.call(field.querySelectorAll('.product-options-single'), function (option) {
        var value = (option.getAttribute('data-val') || '').replace(/\s+/g, ' ').trim().toLowerCase();
        return value.indexOf('beveled edge') === 0 || value.indexOf('bevelled edge') === 0;
      });
      if (!beveled) return;

      beveled.classList.toggle('iyra-option-unavailable', unavailable);
      if (unavailable) {
        var reason = 'Beveled edge is available only when both width and height are ' + limit + '″ or less.';
        beveled.setAttribute('aria-disabled', 'true');
        beveled.setAttribute('aria-describedby', 'iyra-unavailable-option-tooltip');
        beveled.setAttribute('data-iyra-unavailable-reason', reason);
        beveled.removeAttribute('title');

        var selected = selectedLabelValue(field).toLowerCase();
        if (selected.indexOf('beveled edge') === 0 || selected.indexOf('bevelled edge') === 0) {
          var label = field.querySelector('.product-options-label > span');
          if (label) label.textContent = 'None';
          root.querySelectorAll('.mirror-edge input').forEach(function (input) {
            dispatchValue(input, 'None', 0);
          });
        }
      } else {
        beveled.removeAttribute('aria-disabled');
        beveled.removeAttribute('aria-describedby');
        beveled.removeAttribute('data-iyra-unavailable-reason');
        beveled.removeAttribute('title');
        if (beveled === activeUnavailableOption) hideUnavailableTooltip(true);
      }
    }

    function syncAvailability() {
      if (!configurator) return;
      configurator.querySelectorAll(availabilitySelector).forEach(syncAvailabilityField);
      syncBeveledEdgeAvailability();
    }

    function selectedLabelValue(field) {
      var value = field.querySelector('.product-options-label > span');
      if (!value) return '';
      return value.textContent.replace(/\s+/g, ' ').trim();
    }

    function syncSelectedFields() {
      if (!configurator) return;
      configurator.querySelectorAll('.custom-option-select').forEach(function (field) {
        var value = selectedLabelValue(field);
        var hasValue = value !== '' && value.toLowerCase() !== 'select';
        field.classList.toggle('iyra-field-has-value', hasValue);
      });
    }

    if (configurator) {
      root.addEventListener('pointerover', function (event) {
        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (!unavailableOption || !root.contains(unavailableOption)) return;
        if (event.relatedTarget && unavailableOption.contains(event.relatedTarget)) return;
        showUnavailableTooltip(unavailableOption);
      });

      root.addEventListener('pointerout', function (event) {
        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (!unavailableOption || unavailableOption !== activeUnavailableOption) return;
        if (event.relatedTarget && unavailableOption.contains(event.relatedTarget)) return;
        hideUnavailableTooltip();
      });

      root.addEventListener('focusin', function (event) {
        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (unavailableOption && root.contains(unavailableOption)) showUnavailableTooltip(unavailableOption);
      });

      root.addEventListener('focusout', function (event) {
        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (unavailableOption && unavailableOption === activeUnavailableOption) hideUnavailableTooltip();
      });

      root.addEventListener('click', function (event) {
        var unavailableRush = event.target.closest('.product-options-single-rush-no');
        if (unavailableRush && root.contains(unavailableRush)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (unavailableOption && root.contains(unavailableOption)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showUnavailableTooltip(unavailableOption);
          return;
        }
        window.setTimeout(syncAvailability, 0);
        window.setTimeout(syncSelectedFields, 0);
        window.setTimeout(syncConfiguratorDefaults, 0);
        window.setTimeout(syncAvailability, 250);
        window.setTimeout(syncSelectedFields, 250);
        window.setTimeout(syncConfiguratorDefaults, 250);
      }, true);

      root.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var unavailableOption = event.target.closest('.iyra-option-unavailable');
        if (!unavailableOption) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showUnavailableTooltip(unavailableOption);
      }, true);

      root.addEventListener('scroll', function () { hideUnavailableTooltip(true); }, true);
      window.addEventListener('scroll', function () { hideUnavailableTooltip(true); }, { passive: true });
      window.addEventListener('resize', function () { hideUnavailableTooltip(true); }, { passive: true });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') hideUnavailableTooltip(true);
      });

      var essentials = configurator.querySelector('.iyra-mirror-essentials');
      if (essentials) {
        var requiredSelectionObserver = new MutationObserver(syncAddToCartButtonState);
        essentials.querySelectorAll('.product-options-label > span').forEach(function (value) {
          requiredSelectionObserver.observe(value, { childList: true, characterData: true, subtree: true });
        });
      }
      syncAvailability();
      syncSelectedFields();
      syncConfiguratorDefaults();
      window.setTimeout(syncAvailability, 500);
      window.setTimeout(syncSelectedFields, 500);
      window.setTimeout(syncConfiguratorDefaults, 500);
      window.setTimeout(syncConfiguratorDefaults, 1200);
    }

    // Product video rendering is handled exclusively by snippets/product-youtube.liquid.

    updateDisplay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIyraPurchasePanel, { once: true });
  } else {
    initIyraPurchasePanel();
  }
})();
